// module.exports = {}
/* */
export default {
    button: {
        add: "Lisää",
        clone: "Kloonaa",
        delete: "Poista",
        deleteFeedback: "Poista palautteet",
        open: "Avaa",
        save: "Tallenna",
        view: "Näytä",
        prev: "Edell.",
        previous: "Edellinen",
        next: "Seuraava",
        yes: "Kyllä",
        no: "Ei"
    },
    customer: {
        editor: {
            confirmDelete: "Haluatko varmasti poistaa tämän asiakkaan?",
            typeCustomerName: "Kirjoita asiakkaan nimi vahvistaaksesi poiston",
            name: "Asiakaseditori",
            email: "Asiakkaan sähköposti",
        },
        showDisabled: "Näytä käytöstä poistetut asiakkaat",
    },
    clipboard: {
        copied: "Kopioitu!"
    },
    login: {
        in: "Kirjaudu sisään",
        out: "Kirjaudu ulos",
    },
    main: {
        admin: "Järjestelmävalvoja",
        auth0uid: "Auth0 uid",
        contact: "Contact",
        customer: "Asiakas",
        customers: "Asiakkaat",
        dashboardEditor: "Monitorin editori",
        dashboards: "Monitorit",
        email: "Sähköposti",
        name: "Nimi",
        targets: "Kohteet",
        users: "Käyttäjät",
        welcome: "Tervetuloa {{application}} sovellukseen",
        password: "Salasana",
    },
    user: {
        showDisabled: "Näytä käytöstä poistetut käyttäjät",
        editor: {
            name: "Käyttäjäeditori",
            auth0uid: "Auth0 uid",
            confirmDelete: "Haluatko varmasti poistaa käyttäjän: ",
            disabled: "Ei käytössä",
        },
    },
    timestamps: {
        createdAt: "Luotu",
        updatedAt: "Päivitetty",
        timeAt: "klo"
    },
    target: {
        showDisabled: "Näytä käytöstä poistetut kohteet",
        editor: {
            name: "Kohdeeditori",
            available: "Käytettävissä olevat kohteet",
            button: {
                add: "Lisää uusi kohde",
                addLocalisation: "Lisää lokalisointi",
                addQuestionLocalisation: "Lisää kysymyksen lokalisointi",
                addThankYouLocalisation: "Lisää kiitos-sivulle lokalisointi",
                admin: "Järjestelmmävalvoja",
                clone: "Klooni",
                contact: "Kontakti",
                custom: "Asiakas",
                default: "Oletusarvo",
                disabled: "Ei käytössä",
                enable: "Salli",
                enabled: "Aktiivinen",
                feel: "Fiilis",
                generate: "Luo QR-koodi teksteillä",
                generateWithoutTexts: "Luo QR-koodi ilman tekstejä",
                marketing: "Markkinointi",
                next: "Seuraava",
                nps: "NPS",
                open: "Avaa",
                picture: "Tai napsauta tästä valitaksesi kuvan",
                plus: "Plus",
                previous: "Edell.",
                qrCodeGenerator: "QR-koodigeneraattori",
                reversed: "Käänteinen",
                save: "Tallenna",
                special: "Spesiaalit",
                super: "Super",
                view: "Näytä",

            },
            label: {
                additionalQuestions: "Lisäkysymykset",
                baseTarget: "Käytä tämän kohteen tunnistetta ketjussa",
                button1: "Nappi 1",
                button2: "Nappi 2",
                button3: "Nappi 3",
                button4: "Nappi 4",
                button5: "Nappi 5",
                button6: "Nappi 6",
                button7: "Nappi 7",
                button8: "Nappi 8",
                category: "Kategoria",
                customer: "Asiakas",
                description: "Kuvaus",
                enable: "Ota käyttöön",
                endPage: "Loppusivu",
                feedbackQuestionNegative: "Palautekysymys, jos negatiivinen (-)",
                feedbackQuestionNeutral: "Palautekysymys, jos neutraali",
                feedbackQuestionPositive: "Palautekysymys, jos positiivinen (+)",
                getback: "Palaa tähän viimeisen kohteen jälkeen",
                iconsOrder: "Kuvakkeiden järjestys",
                iconsPath: "Kuvakkeiden polku",
                imageButton: "Kuvapainike",
                languageMenu: "Kielivalikko",
                legalNotice: "Tietosuoja",
                legalNoticeURL: "Tietosuojan URL-linkki",
                linked: "Linkitetty",
                locationEnabled: "Sijainti käytössä",
                lotteryRules: "Arvonnan säännöt",
                lotteryRulesURL: "Sääntöjen URL-linkki",
                maxValue: "Maksimiarvo",
                measurementType: "Mittaus",
                minValue: "Minimiarvo",
                noVoting: "Arvosanaa ei kysytä",
                optionalFields: "Valinnaiset kentät",
                optionalQuestions: "Valinnaiset kysymykset",
                otherSettings: "Muut asetukset",
                parent: "Vanhempi",
                picture: "Kuva",
                question: "Kysymys",
                showNPSfooter: "Näytä NPS-alatunniste",
                skipButton: "Ohita-painike",
                subtitle: "Alaotsikko",
                tags: "Tunnisteet",
                thanksText: "Kiitos teksti",
                thankYouPage: "Kiitossivu",
                theme: "Teema",
                title: "Otsikko",
                topicButtons: "Aihepainikkeet",
                topicButtonsSubtitle: "Alaotsikko",
                topicButtonsTitle: "Otsikko",
                votingLimit: "Äänestysraja",
                votingLimitKey: "Äänestysrajan avain",
                votingLimitTime: "Äänestysraja sekunneissa",
                votingScale: "Äänestysskaala",
                whistleblower: "Whistleblower",
                dropZeroNPS: "NPS nolla-arviota ei kerätä",
                dropNegativeNPS: "Negatiivisia NPS-arviota ilman palautetekstiä ei kerätä",
                noAutosubmitWhenEmpty: "Tyhjiä palautteita ei lähetetä automaattisesti",
            },
            confirmDelete: "Haluatko varmasti poistaa kohteen: ",
            confirmDeleteFeedback: "Haluatko varmasti poistaa palautteet, jotka on annettu kohteelle: ",
            contact: {
                contactMe: "Ota yhteyttä",
                contactFormTitle: "Yhteydenottolomakkeen otsikko",
                showName: "Näytä nimi",
                showCompany: "Näytä yritys",
                showEmail: "Näytä sähköposti",
                showPhone: "Näytä puhellinnumero",
                showRoom: "Näytä huoneen numero",
                showTeam: "Näytä tiimi",
                showAddress: "Näytä osoite",
                showZIP: "Näytä postinumero",
                showCity: "Näytä kaupunki",
                showCountry: "Näytä maa",
                showAge: "Näytä ikä",
                showGenre: "Näytä sukupuoli",
                title: "Kontakti",
            },
            custom: {
                custom1: "Custom 1",
                custom2: "Custom 2",
                custom3: "Custom 3",
                custom4: "Custom 4",
                custom5: "Custom 5",
                custom6: "Custom 6",
                title: "Custom",
            },
            marketing: {
                noSMS: "Ei markkinoinnin tekstiviestejä",
                noEmail: "No markinointisähköpostia",
                noCall: "No puhelinmarkkinointia",
                noText: "Ei markkinointiviestejä",
                title: "Marketing",
            },
            special: {
                linkingTarget: "Linkitetty kohde",
                styleSettings: "Tyyliasetukset",
                title: "Spesiaalit",
            },
            qrCode: {
                scale: "QR-koodin koko",
                title: "QR-koodin otsikko",
                URL: "QR-koodin URL-linkki",
                warning: "Testaa QR-koodi aina ennen käyttöä",
            },
            question: {
                add: "Lisää",
            },
        },
    },
    dashboard: {
        name: "Monitorin editori",
        showDisabled: "Näytä käytöstä poistetut monitorit",
        editor: {
            available: "Käytettävissä olevat monitorit",
            authenticated: "Autentikoitu",
            availableDashboards: "Valittavissa olevat monitorit",
            availableTargets: "Valittavissa olevat kohteet",
            buttonVisibility: "Palautepainikkeiden näkyvyys",
            // users: "Users",
            chart: {
                showFeelings: "Fiilismittari",
                showCustomerFeelings: "Asiakasfiilismittari",
                showEmployeeFeelings: "Työfiilismittari",
                showHistory: "Historiakuvaaja",
                showNPS: "NPS-mittari",
                showENPS: "eNPS-mittari",
                showNPSDis: "NPS-jakauma erikseen",
                showPie: "Piirakkakaavio",
                showPlus: "Plusmittari",
                showOverviewIcon: "Yleiskuvan ikoni"
            },
            chartVisibility: "Kuvaajien näkyvyys",
            commentsbcc: "Kommentoinnin Bcc",
            confirmDelete: "Haluatko varmasti poistaa monitorin: ",
            disabled: "Monitori poistettu käytöstä",
            enableAnalytics: "Raportin tilausmahdollisuus",
            feedback: {
                show: {
                    disabled: "Näytä käytöstä poistetut monitorit",
                    empty: "Näytä myös tyhjät palautteet",
                    feedback: "Näytä palaute",
                    image: "Näytä kuva",
                    show: "Näytä palaute",
                    time: {
                        range: "Aikaväli",
                    },
                },
            },
            feedbackVisibility: "Palautteiden näkyvyys",
            name: "Monitorin nimi",
            ratingButtons: {
                showStatus: "\"Tila\"",
                showCommentsBtn: "\"Näytä kommentit\"",
                showStarBtn: "\"Merkitse tärkeäksi\"",
                showHideBtn: "\"Piilota\"",
                showCloseBtn: "\"Poista\"",
                showPublishBtn: "\"Julkaise\"",
                showLikeBtn: "\"Peukuta\"",
            },
            showImage: "Näytä kuvat",
            showDisabled: "Näytä käytöstä poistetut kohteet",
            notificationLink: "Ilmoituksiin monitorin linkki",
            comments: {
              email: "Sähköpostikommentit",
            },
            layout: {
                public: "Julkinen layout",
            },
            theme: "Teema",
            type: "Tyyppi",
            security: {
                autheticated: "Authentikoitu",
            },
            time: {
                dateFormat: "yyyy.MM.dd HH:mm",
                from: "Mistä",
                label: "Aika",
                range: "Aikaväli",
                timeFormat: "HH:mm",
                to: "Mihin",
            },
            users: "Käyttäjät",
        },
    },
};
/**/
